import { useEffect } from "react";
import { Grid } from "@mui/material";
import {
  Create,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
  useNotify,
  useRedirect,
} from "react-admin";
import { useLocation } from "react-router-dom";
import { errorMessages } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import { doctoralRequests } from "api/doctoralApi";
import { DoctoralServicePath } from "utils/constants";
import { DoctoralSchoolPaymentProviderChoices } from "utils/choices";
import PersonalInfoSection from "../../ApprovedCandidacies/Enroll/PersonalInfoSection";


const ExternalDoctoralSchoolCandidate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const location = useLocation();

  const { doctoralSchoolCampaignId } = location.state || {};
  const listPath = `/${DoctoralServicePath}doctoral-school-campaigns/${doctoralSchoolCampaignId}/show`;

  useEffect(() => {
    if (!doctoralSchoolCampaignId) redirect(`/${DoctoralServicePath}doctoral-school-campaigns`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const transform = form => ({
    doctoralSchoolCampaignId,
    currentUniversity: form.currentUniversity,
    currentDoctoralProgram: form.currentDoctoralProgram,
    paymentProviderId: form.paymentProviderId,
    personalInfo: {
      firstName: form.firstName,
      secondName: form.secondName,
      lastName: form.lastName,
      personId: form.personId,
      email: form.email,
      gender: form.gender,
      contactPhone: form.contactPhone,
    },
  });

  return (
    <Create
      resource={doctoralRequests.createExternalDoctoralSchoolDoctorant()}
      title="Външен кандидат за докторантско училище"
      transform={transform}
      mutationOptions={{
        onSuccess: () => {
          notify("Кандидатът е добавен успешно", { type: "success" });
          redirect(listPath);
        },
        onError: err => {
          notify(err.message || errorMessages[err.errorCode] || errorMessages.default, { type: "error" });
        },
      }}
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SectionTitle paddingY={2} title="Лични данни" />
        <PersonalInfoSection />

        <SectionTitle paddingY={2} title="Идентификация" />
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextInput source="personId" label="ЕГН / ЛНЧ" validate={required("Задължително")} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput source="email" label="Имейл" validate={required("Задължително")} fullWidth />
          </Grid>
        </Grid>

        <SectionTitle paddingY={2} title="Текущо обучение" />
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextInput
              source="currentUniversity"
              label="Научна организация"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput
              source="currentDoctoralProgram"
              label="Докторантска програма"
              fullWidth
            />
          </Grid>
        </Grid>

        <SectionTitle paddingY={2} title="Плащане" />
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <SelectInput
              source="paymentProviderId"
              label="Начин на плащане"
              choices={DoctoralSchoolPaymentProviderChoices}
              validate={required("Задължително")}
              fullWidth
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export default ExternalDoctoralSchoolCandidate;
